<template>
    <div>
        <div class="soli-grey flex justify-center" v-if="teacher && onlineOnly">
            {{ `${teacher.first_name} is only available for online lessons` }}
        </div>
        <v-list>
            <v-list-item>
                <SoliAvatarBtn
                    title="In-Studio"
                    @click="$emit('input', false)"
                    icon="storefront"
                    blue
                    :disabled="onlineOnly"
                    :subtitleBottom="location?.name"
                ></SoliAvatarBtn>
            </v-list-item>
            <v-list-item>
                <SoliAvatarBtn
                    title="Online"
                    @click="$emit('input', true)"
                    icon="videocam"
                    blue
                    subtitleBottom="Zoom or Google Meet"
                ></SoliAvatarBtn>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    name: "SoliOnline",
    props: ["online", "teacher", "onlineOnly", "location"],
    data() {
        return {};
    },
};
</script>
